import { useCurrencyConverter } from '~/composables/useCurrencyConverter';
import type { ISsWinners, TSsWinnersResponse, ISsWinnersSlider } from '~/types/softswiss/ssWinners';

export const parsePreloadWinners = (preloadWinners: TSsWinnersResponse) => {
  const preloadWinnersParsed: ISsWinners[] = [];

  preloadWinners?.forEach((element) => {
    preloadWinnersParsed.push({
      at: element.at,
      game: {
        id: element.game_identifier,
        provider: element.provider,
        title: element.game_title,
      },
      player: { nickname: element.nickname },
      round: {
        bet: element?.bet_amount_cents || 0,
        currency: element.currency,
        win: element?.win_amount_cents || 0,
        humanized_win: element?.humanized_win || '',
      },
    });
  });

  return preloadWinnersParsed;
};

export const parseWinner = (winner: ISsWinners): ISsWinnersSlider => {
  const { convertToFormattedAmount } = useCurrencyConverter();

  let formattedAmountWin = winner.round.humanized_win
    ?.split(' ')[0]
    .replace(/,/g, '')
    .replace('$', '')
    .replace('€', '');

  if (winner.round.currency === 'USDT') {
    formattedAmountWin = `${Number(formattedAmountWin).toFixed(2)}`;
  }

  const formattedCurrencyWin = winner.round.currency;

  const { formattedAmount: formattedAmountBet } = convertToFormattedAmount(
    winner.round.bet,
    winner.round.currency
  );

  return {
    // create unique ID for DOM
    id: `${winner.player.nickname}_${winner.game.id}_${winner.round.win}_${winner.at}`,
    game: winner.game,
    player: winner.player,
    prize: `${formattedAmountWin} ${formattedCurrencyWin}`,
    win_amount_formatted: formattedAmountWin,
    bet_amount_formatted: formattedAmountBet,
    currency: winner.round.currency,
    multiplayer: Math.ceil(winner.round.win / winner.round.bet),
  };
};
